<template>
    <div class="container-fluid mt-4">
        <div class="devices-title">Devices</div>
        <div class="devices-subtitle">The devices where the user is active</div>
        <div class="card mt-2" :class="{'loading': loading.data}">
            <div class="card-body p-0">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th>Device ID</th>
                            <th>Device</th>
                            <th width="116">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="device in devices" v-bind:key="device.deviceId">
                            <td>
                                {{ device.device_id }}
                            </td>
                            <td>
                                {{ device.device_name }}
                            </td>
                            <td style="white-space: nowrap; text-align: right">
                                <a class="me-2" href="#" @click="deleteDevice(device)">
                                    <inline-svg src="/assets/img/icons/trash-01.svg"></inline-svg>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <btn class="btn-primary mt-2" @click="addDevice">
            <inline-svg class="me-1" src="/assets/img/icons/plus.svg"></inline-svg>
             Add a new Device
        </btn>

        <modal name="addDeviceModal" height="auto" width="640px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="w-100 text-center">
                        <inline-svg class="mb-1" src="/assets/img/icons/device.svg"></inline-svg>

                        <h4 class="modal-title">Add a new device</h4>
                        <div>
                            Connect to a new device for this Hero
                        </div>
                    </div>
                </div>

                <div class="modal-body">
                    <form-group help="You can find it in the Menu Tab, under Account Settings">
                        <form-input inputClass="form-control-lg" placeholder="Enter Device ID"
                                    v-model="add_device.device_id" :v="$v.add_device.device_id"/>
                    </form-group>
                    <div class="text-center my-2">OR</div>
                    <div class="d-flex align-items-start">
                        <div id="qr-code">
                            <qrcode-vue :size="187" v-if="token" :value="token"></qrcode-vue>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <b>Scan the QR code with your device</b><br>
                                You can also scan this QR code using the device you want to pair
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer flex-row align-items-center justify-content-center">
                    <btn class="btn-outline-light btn-lg flex-1" @click="stopTokenVerification(); $modal.hide('addDeviceModal')">Cancel</btn>
                    <btn class="btn-primary btn-lg flex-1" :disabled="!add_device.device_id" :loading="loading.save" @click="saveDevice()">Add Device</btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";
import {mapState} from "vuex";
import QrcodeVue from 'qrcode.vue'

export default {
    name: 'HeroDevices',
    props: ['hero'],
    components: {
        QrcodeVue,
    },
    data() {
        return {
            loading: {
                data: false,
                token: false,
                save: false,
            },
            add_device: {
                user_id: '',
                device_id: ''
            },
            devices: [],
            token: null,
            verifyInterval: null
        };
    },
    validations: {
        add_device: {
            device_id: {required: required},
        },
    },
    computed: {
        ...mapState({
            user: state => state.user,
        }),
    },
    mounted() {
        this.getDevices();
        // this.$events.$on('loadDevices', this.getDevices);
    },
    beforeDestroy() {
        this.stopTokenVerification();
    },
    methods: {
        getDevices() {
            this.loading.data = true;
            this.$http.post("/device/user-list", {
                user_id: this.$route.params.hero_id
            })
                .then((res) => {
                    this.devices = res.body.data.devices;
                    this.loading.data = false;
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        },
        getUserToken() {
            this.loading.token = true;
            this.$http.post("/device/get-user-token", {
                user_id: this.hero.id,
                action: "associate",
            })
                .then((res) => {
                    this.token = res.body.data.token;
                    this.loading.token = false;
                    this.startTokenVerification();
                })
                .catch((error) => {
                    this.loading.token = false;
                });
        },
        startTokenVerification() {
            this.stopTokenVerification();
            this.verifyInterval = setInterval(() => {
                this.$http.post("/device/verify-user-token", {
                    token: this.token
                })
                    .then((res) => {
                        if (res.body.data.used || res.body.data.expired) {
                            this.stopTokenVerification();
                            this.$modal.hide('addDeviceModal');
                            this.getDevices();
                        }
                    })
                    .catch(() => {});
            }, 5000);
        },
        stopTokenVerification() {
            if (this.verifyInterval) {
                clearInterval(this.verifyInterval);
                this.verifyInterval = null;
            }
        },
        addDevice() {
            this.stopTokenVerification();
            this.add_device = {
                user_id: this.hero.id,
                device_id: '',
            };
            this.getUserToken();
            this.$modal.show('addDeviceModal');
        },
        saveDevice() {
            this.$v.add_device.$touch();
            if (this.$v.add_device.$invalid == true) {
                return false;
            }
            this.loading.save = true;
            this.$http.post('/device/add-to-user', this.add_device)
                .then((res) => {
                    this.loading.save = false;
                    this.stopTokenVerification();
                    this.getDevices();
                    this.$modal.hide('addDeviceModal');
                })
                .catch((error) => {
                    this.loading.save = false;
                });
        },
        deleteDevice(device) {
            const self = this;
            this.$dialog.confirm('Are you sure you want to delete the device?', {
                okText: 'Yes',
                cancelText: 'No',
            }).then(() => {
                self.loading.delete = true;
                self.$http.post("/device/remove-from-user", {user_id: self.$route.params.hero_id, device_id: device.device_id})
                    .then(() => {
                        this.getDevices();
                        self.loading.delete = false;
                    })
                    .catch(() => {
                        self.loading.delete = false;
                    });
            });
        },
    },
};
</script>
